import { createI18n } from 'vue-i18n';
import { de, fr } from 'vuetify/locale';
import messages from '@intlify/unplugin-vue-i18n/messages';

const v18nInstance = createI18n({
  legacy: false, // you must set `false`, to use Composition API
  availableLocales: ['de-CH', 'de-DE', 'fr-CH'],
  locale: 'de-CH', // set locale
  fallbackLocale: {
    'de-DE': ['de-CH'],
    fr: ['fr-CH'],
    default: ['de-CH'],
  },
  numberFormats: {
    'de-DE': {
      currency: {
        style: 'currency',
        currency: 'EUR',
      },
    },
    'de-CH': {
      currency: {
        style: 'currency',
        currency: 'CHF',
      },
    },
    'fr-CH': {
      currency: {
        style: 'currency',
        currency: 'CHF',
      },
    },
  },
  messages: {
    'de-CH': { $vuetify: de, ...messages!['de-CH'] },
    'de-DE': { $vuetify: de, ...messages!['de-DE'] },
    'fr-CH': { $vuetify: fr, ...messages!['fr-CH'] },
  },
  // Configuration options for v18n
});

export default v18nInstance;
